module.exports = __webpack_public_path__ + "2fb9a727dfe3b5fc87146121043fe97c.jpg";


//////////////////
// WEBPACK FOOTER
// ./apps/www.relic.com/src/img/styles/thumbnail/public/images/studio5.jpg
// module id = 529
// module chunks = 0